import uuid from 'uuid-random';

import { addPopupAction, LAYER } from '@core/js/components/common/PopupManager';

import { UpgradeMemberPopup } from './UpgradeMemberPopup';

export const showUpgradeMemberPopupAction = ({ membershipNumber } = { membershipNumber: '' }) =>
    addPopupAction({
        id: uuid(),
        component: UpgradeMemberPopup,
        layer: LAYER.LOGIN,
        membershipNumber,
        closeAll: true
    });
